enum ErrorCode {
  SessionTimeOut = 'sessionTimeOut',
  InvalidSessionId = 'invalidSessionId',
  ItemOutOfStock = 'itemOutOfStock',
  InvalidVariant = 'invalidVariant',
  PersonalisationIllegalCharacters = 'personalisationIllegalCharacters',
  PersonalisationTooLong = 'personalisationTooLong',
  ItemUnavailable = 'itemUnavailable',
}
export default function ErrorMessageHandler(type: string): string {
  let returnMessage = '';

  switch (type) {
    case ErrorCode.PersonalisationIllegalCharacters:
      returnMessage = 'Unable to add item to basket as the personalised field contains illegal characters';
      break;
    case ErrorCode.PersonalisationTooLong:
      returnMessage = 'Personal message is too long';
      break;
    case ErrorCode.ItemOutOfStock:
      returnMessage = 'Sorry, this item is out of stock';
      break;
    case ErrorCode.ItemUnavailable:
      returnMessage = 'Sorry, this item is currently unavailable';
      break;

    default:
      returnMessage = 'There has been a technical issue. Please reload the page and try again or try again later.';
      break;
  }
  return returnMessage;
}
